import ENDPOINTS from '../../constants/apiEndPoints';
import {axiosInstance} from '../axiosInstance';

export const handleGetAllClientsService = async (
  params: Record<string, any>,
) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_CREATE_CLIENT, {
    params,
  });
  return response?.data;
};

export const handleGetBranchesByClientService = async (clientId: string) => {
  const response = await axiosInstance.get(
    ENDPOINTS.GET_BRANCHES_BY_CLIENT(clientId),
  );
  return response?.data;
};


export const handleGetClientByLoggedInUserService = async () => {
  const response = await axiosInstance.get(
    ENDPOINTS.GET_USER_CLIENT
  );
  return response?.data;
};
